module.exports = __webpack_public_path__ + "img/intro-2.8ec44bcd.jpg";